import { useInfiniteQuery, useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import * as logsService from "../services/logsService";

export function useLogsQuery({ severity, component, dateFrom, dateTo, search }) {
  return useInfiniteQuery({
    queryKey: ["logs", { severity, component, dateFrom, dateTo, search }],
    queryFn: ({ pageParam }) =>
      logsService.fetchLogs({ severity, component, dateFrom, dateTo, search, offset: pageParam }),
    initialPageParam: 0,
    getNextPageParam: (lastPage, allPages) =>
      lastPage.hasMore ? allPages.flatMap((p) => p.rows).length : undefined,
  });
}

export function useComponentOptionsQuery() {
  return useQuery({
    queryKey: ["logs", "componentOptions"],
    queryFn: logsService.fetchComponentOptions,
    staleTime: Infinity,
  });
}

export function usePurgeLogs() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: logsService.purgeLogs,
    onSuccess: () => {
      queryClient.removeQueries({ queryKey: ["logs"] });
    },
  });
}
